export default "__VITE_ASSET__DpT64yg0__"